import {
  FETCH_DROPDOWNLIST_REQUEST,
  FETCH_DROPDOWNLIST_SUCCESS,
  FETCH_DROPDOWNLIST_FAILURE,
} from "./dropdownDataTypes";

const initialState = {
  loading: false,
  dropdownList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DROPDOWNLIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_DROPDOWNLIST_SUCCESS:
      return {
        loading: false,
        dropdownList: action.payload,
        error: "",
      };
    case FETCH_DROPDOWNLIST_FAILURE:
      return {
        loading: false,
        dropdownList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
